import React from 'react';
import Highlight from '../Highlight/Highlight.jsx';

const SearchSuggestionsNosto = ({
    query,
    suggestions,
    handleSuggestionClick,
}) => {
    const formatSuggestion = (text) => {
        return text.replace(/_/g, ' - ');
    };

    // Handle suggestion click with attribution tracking
    const handleSuggestionClickWithAttribution = (suggestion) => {
        // Record attribution for suggestion click
        if (typeof window !== 'undefined' && window.nostojs) {
            window.nostojs((api) => {
                api.recordAttribution({
                    type: 'is', // Internal Search
                    target: suggestion,
                    ref: 'search-suggestions'
                })
                    .done()
                    .then((data) => {
                        console.log('Nosto suggestion click attribution recorded:', data);
                    })
                    .catch((error) => {
                        console.error('Nosto suggestion click attribution error:', error);
                    });
            });
        }

        // Call the original handler
        handleSuggestionClick(suggestion);
    };

    return (
        <div className='flyout-section flyout-section-outer suggestions-section mt-1 mb-4'>
            <div className='flyout-section-inner'>
                <h3 className='flyout-section-title text-base md:text-lg mb-1 md:mb-2'>
                    Suggestions
                </h3>
                {suggestions && suggestions.length > 0 ? (
                    <ul className='suggestions-list nostyle grid grid-cols-2 md:grid-cols-1 gap-1 md:gap-2'>
                        {suggestions.map((suggestion, index) => (
                            <li
                                key={index}
                                className='text-[13px] py-1'
                            >
                                <button
                                    className='font-normal text-flint hover:text-ash hover:underline cursor-pointer w-full text-left'
                                    onClick={() => handleSuggestionClickWithAttribution(suggestion)}
                                >
                                    <Highlight search={query}>
                                        {formatSuggestion(suggestion)}
                                    </Highlight>
                                </button>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div className='no-results'>
                        <p className='font-normal text-flint text-sm'>
                            No suggestions found
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchSuggestionsNosto;
